<template>
  <div v-if="![3, 4].includes(adminUserType)">
    <div class="header-box" :style="{ background: getHeaderBackground() }">
      <div class="header-logo">
        <div class="d-i-b log-box">
          <img :src="user.mainLogoImage || require('/public/img/logonew.png')" alt="" height="43" class="imgbox" />
        </div>
      </div>
      <div class="campus-box" v-if="campusList.length > 1">
        <el-dropdown trigger="click" @command="switchCampus" v-if="packageJson.name != 'base'">
          <span class="el-dropdown-link">
            {{ currentCampus.name
            }}<i class="el-icon-arrow-down el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown" style="max-height: 500px; overflow-y: auto">
            <el-dropdown-item v-for="item in campusList" :key="item.id" :command="item">{{ item.name
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="menu-title">
        <el-tabs @tab-click="tabClick($event, 1)" v-model="activeName" :before-leave="beforeLeave">
          <el-tab-pane v-for="item in menuList.slice(0, 5)" :key="item.id" :name="item.id">
            <span slot="label">
              <el-tooltip :disabled="item.name.length < 10" class="item" effect="dark" :content="item.name"
                placement="bottom" :enterable="false">
                <span> {{ item.name }} </span>
              </el-tooltip>
            </span>
          </el-tab-pane>
        </el-tabs>
        <div class="more" v-if="menuList.length > 5">
          <el-dropdown trigger="click" :custom-class="'more-box'" placement="top" ref="dropdown">
            <span class="el-dropdown-link">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <draggable v-model="menuList" animation="300" :disabled="disabled" filter=".undraggable" :move="onMove">
                <transition-group class="more-dropdown-box">
                  <div :class="[
                    'more-dropdown-item',
                    item.id == 'workTable' ? 'undraggable' : '',
                  ]" :style="{
                    cursor:
                      !disabled && item.id == 'workTable'
                        ? 'no-drop'
                        : !disabled
                          ? 'move'
                          : 'pointer',
                  }" v-for="(item, index) in menuList" :key="item.id" @click="tabClick({ name: item.id }, 2)">
                    <div class="item-img-box">
                      <img :src="item.iconPath + '/' + item.iconObject" alt="" width="40" height="40"
                        v-if="item.iconObject && item.iconObject" />
                      <span v-else class="item-img-icon">{{
                        item?.name[0]
                      }}</span>
                    </div>
                    <span class="item-name">
                      <el-tooltip v-if="item.name.length > 5" effect="dark" :content="item.name" placement="bottom">
                        <span class="item-name-span">{{ item.name }}</span>
                      </el-tooltip>
                      <span v-else class="item-name-span">{{ item.name }}</span>
                    </span>
                  </div>
                </transition-group>
              </draggable>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <!-- <div class="search">
        <el-input
          v-model="searchValue"
          placeholder="搜索"
          prefix-icon="el-icon-search"
          style="width: 80px"
          size="small"
        ></el-input>
      </div> -->
      <div style="" class="user-name-text">
        {{ user.name }}
      </div>
      <div class="setting" v-if="adminUserType != 0" style="left: -15px; margin-right: 8px">
        <!-- <i class="iconfont icon-xiaoxi1" style="color: #fff"></i> -->
        <el-badge :value="totalCount" class="item-el-badge" :max="99" v-if="totalCount != 0"></el-badge>
        <i class="iconfont icon-xiaoxi1" style="font-size: 20px; color: #aab1bb" @mouseover="getSubscribe(1)"></i>
        <el-drawer title="我是标题" :visible.sync="drawer" :with-header="false" size="320px" :modal="false"
          style="top: 50px">
          <div v-loading="drawerlaoding" style="height: 100%">
            <div class="drawer-title">
              <span>消息中心</span>
              <div class="urlgo">
                <a @click="gonewpath('message-web/meMessage/user')">更多消息</a>
              </div>
            </div>
            <div v-if="Subscribe.length" class="box-drawer">
              <div v-for="(item, index) in Subscribe" :key="index" :class="['title-li', 'hovertitle']"
                @click="gonewpath('message-web/meMessage/user', item.id)">
                <div class="drawer-tie">
                  【{{ item.eventName }}】 {{ item.title }}
                </div>
                <div style="font-size: 12px; margin: 5px 0 0 0px">
                  {{ item.realitySendTime.split("T")[0] }}
                  {{ item.realitySendTime.split("T")[1] }}
                </div>
              </div>
            </div>
            <div v-else class="nodesic">暂无消息</div>
          </div>
        </el-drawer>
      </div>
      <div class="user">
        <div class="user-center">
          <el-dropdown trigger="click" @command="dropdownClick">
            <span class="el-dropdown-link">
              <div class="user-box">
                <el-avatar size="medium" :src="GET_HEADSTYLE || require('../../assets/user.png')"></el-avatar>
              </div>
              <i class="el-icon-caret-bottom" style="color: #fff"> </i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="/userInfo/index" v-if="disableTenant.state == 0">个人中心</el-dropdown-item>
              <el-dropdown-item command="theme" v-if="disableTenant.state == 0">主题配置</el-dropdown-item>
              <el-dropdown-item command="logout">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <!-- 主题色 -->
    <el-dialog title="个性化设置" :visible.sync="commonShow" width="800px" @close="nocolorcheck">
      <div class="colorheard">
        <!-- <div class="color_tip">
          <i class="el-icon-warning-outline"></i>
          根据您的喜好选择喜欢的颜色，该设置只对您的账号有效，其他成员不受影响
        </div> -->
        <el-alert class="tab-peon" title="根据您的喜好选择喜欢的颜色，该设置只对您的账号有效，其他成员不受影响" type="info" :closable="false" show-icon>
        </el-alert>
      </div>
      <diV class="colortable">
        <div :class="['box-color', currentColor == item.value ? 'checkcolor' : '']" :style="{
          border: `1px solid ${currentColor == item.value ? item.value : '#E6E8ED'
            }`,
        }" v-for="(item, index) in colorList" :key="index" @click="switchColor(item.value)">
          <div class="box-v">
            <div class="box-v-min">
              <div class="box-v-min-left" :style="{ background: item.value }">
                <div class="round" :style="{ background: item.icColor }"></div>
                <div class="cross-box">
                  <div class="cross" v-for="it in 4" :style="{ background: item.icColor }"></div>
                </div>
              </div>
              <div class="box-v-min-right">
                <div class="box-v-min-right-header"></div>
                <div class="box-v-min-right-content"></div>
              </div>
            </div>
          </div>
          <p class="box-name">{{ item.name }}</p>
        </div>
      </diV>
      <span slot="footer" class="dialog-footer">
        <el-button @click="nocolorcheck" size="small">取 消</el-button>
        <el-button type="primary" @click="switchColorok(currentColor)" :loading="paixload" size="small">保存</el-button>
      </span>
    </el-dialog>
  </div>
  <div v-else>
    <div class="center-box">
      <div class="headerRR-box">
        <div class="headerRR-box-left">
          <div class="header-logo" @click="goIndex()">
            <div class="d-i-b log-box">
              <img :src="user.mainLogoImage || require('/public/img/logonew.png')" alt="" height="55" width="270px"
                class="imgbox" />
            </div>
          </div>
          <div class="teacher-menu">
            <div class="menu-box">
              <el-tabs @tab-click="menuClick($event)" v-model="activeNameCC" :before-leave="beforeLeave"
                class="semenu-horizontal" :class="terMenuList.length > 9 ? 'semenu-horizontal-Qei9' : ''">
                <el-tab-pane v-for="item in terMenuList" :key="item.id" :name="item.id">
                  <template slot="label">
                    <div class="menu-item">
                      <div class="item-box">
                        <div class="item-icon">
                          <i class="t-icon" :class="`t-${item.icon}`"></i>
                        </div>
                        <div class="item-name">{{ item.name }}</div>
                      </div>
                    </div>
                  </template>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
        <div class="header-right">
          <div class="user-r-lls">
            <div class="user-box">
              <div class="user-box-box">
                <div class="user-img">
                  <!-- <img
                    :src="userInfor.userImage"
                    alt=""
                    width="60px"
                    height="60px"
                  /> -->
                  <el-avatar :src="GET_HEADSTYLE || require('../../assets/user.png')" :size="60"></el-avatar>
                </div>
                <div class="user-info">
                  <div class="user-name">
                    <span> {{ userInfor.name }}</span>
                    <span>
                      <el-button size="small" style="font-size: 16px; padding: 0; line-height: 15px" type="text"
                        @click="personalClick">个人中心</el-button>
                    </span>
                  </div>
                  <div class="user-school">
                    <div class="school-name" :title="schoolName">
                      {{ schoolName }}
                      <!-- <div>安徽开放大学</div>

                    <div>合肥外国语-202401-软件技术(专升本-函授)</div> -->
                    </div>

                    <div class="switch-school" v-if="switchSchoolState" @click="swsscChange">
                      切换学校
                    </div>
                  </div>
                </div>
                <div class="setting" v-if="adminUserType != 0" style="top: -18px">
                  <!-- <i class="iconfont icon-xiaoxi1" style="color: #fff"></i> -->
                  <el-badge :value="totalCount" class="item-el-badge" :max="99" v-if="totalCount != 0"></el-badge>
                  <i class="iconfont icon-xiaoxi1" style="font-size: 20px; color: #aab1bb" @click="getSubscribe(1)"></i>
                  <el-drawer title="我是标题" :visible.sync="drawer" :with-header="false" size="320px" :modal="false">
                    <div v-loading="drawerlaoding" style="height: 100%">
                      <div class="drawer-title">
                        <span>消息中心</span>
                        <div class="urlgo">
                          <a @click="gonewpath('message-web/meMessage/user')">更多消息</a>
                        </div>
                      </div>
                      <div v-if="Subscribe.length" class="box-drawer">
                        <div v-for="(item, index) in Subscribe" :key="index" :class="['title-li', 'hovertitle']" @click="
                          gonewpath('message-web/meMessage/user', item.id)
                          ">
                          <div class="drawer-tie">
                            【{{ item.eventName }}】 {{ item.title }}
                          </div>
                          <div style="font-size: 12px; margin: 5px 0 0 0px">
                            {{ item.realitySendTime.split("T")[0] }}
                            {{ item.realitySendTime.split("T")[1] }}
                          </div>
                        </div>
                      </div>
                      <div v-else class="nodesic">暂无消息</div>
                    </div>
                  </el-drawer>
                </div>
              </div>
            </div>
            <div>
              <el-button size="small" type="danger" @click="logout" style="position: relative">退出</el-button>
            </div>
          </div>
          <div class="shcooll-bbsr" v-if="stuInforName">
            <div :title="stuInforName" class="stuInforName-iits">
              {{ stuInforName }}
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="center-box-tst">
        <div class="teacher-menu">
         
        </div>
      </div> -->
    </div>
    <!-- 批阅类型选择2 -->
    <el-dialog :visible.sync="readDialogVisible" title="选择批阅类型" width="360px" :close-on-click-modal="false"
      :show-close="false" center>
      <span style="display: flex; justify-content: center; gap: 20px; margin-bottom: 30px;">
        <el-button type="primary" size="small" @click="headerGoReadPlatform('1')">正考批阅教师</el-button>
        <el-button type="success" size="small" @click="headerGoReadPlatform('2')">补考批阅教师</el-button>
      </span>
    </el-dialog>
    <el-dialog title="切换学校" :visible.sync="switchSchoolVisible" width="850px">
      <div class="switch-school-box">
        <!-- <el-select
          v-model="switchSchoolId"
          size="small"
          clearable
          placeholder="请选择要切换的学校"
        >
          <el-option
            v-for="item in schoolList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          />
        </el-select> -->
        <el-tabs v-model="activeSwitch" @tab-click="handleSwitch">
          <el-tab-pane label="教师角色" name="js" v-if="teaSchoolList.length">
            <el-radio-group v-model="switchSchoolId">
              <el-radio :label="item.id" v-for="item in teaSchoolList" :key="item.id" :title="item.schoolName">{{
                item.schoolName }}</el-radio>
            </el-radio-group>
          </el-tab-pane>
          <el-tab-pane label="学生角色" name="xs" v-if="stuSchoolList.length">
            <el-radio-group v-model="switchSchoolId">
              <el-radio :label="item.id" v-for="item in stuSchoolList" :key="item.id" :title="item.schoolName">
                <div>
                  <div>{{ item.schoolName }}</div>
                  <div v-if="item.isNonDegree !== 1" :title="item.studentStatus" class="nodesic-llr">
                    {{ item.studentStatus }}
                  </div>
                </div>
              </el-radio>
            </el-radio-group>
          </el-tab-pane>
        </el-tabs>
        <!-- <el-radio-group v-model="switchSchoolId">
          <el-radio
            :label="item.id"
            v-for="item in schoolList"
            :key="item.id"
            :title="item.schoolName"
            >{{ item.schoolName }}</el-radio
          >
        </el-radio-group> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="switchSchoolVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="switchSchoolChange">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="payStuShow" width="1400px" :close-on-click-modal="false" title="缴费提醒" center>
      <div class="stu-infor f-display-flex">
        <!-- 头像 -->
        <div class="stu-infor-img">
          <img width="111" height="120" :src="singleStuInfor.idPhoto || require('../../assets/user.png')" />
        </div>
        <div class="stu-infor-box">
          <div class="stu-infor-box-item f-padding-bottom-10">
            <el-row>
              <el-col :span="8">
                <div class="f-display-flex">
                  <div class="one-1 f-line-height-24 f-color-A4 f-stu-font-16">
                    姓名：
                  </div>
                  <div class="f-color-3C f-line-height-24 f-line-height-27 one-2">
                    {{ singleStuInfor.name }}
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="f-display-flex">
                  <div class="one-1 f-line-height-24 f-color-A4 f-stu-font-16">
                    身份证：
                  </div>
                  <div class="f-color-3C f-line-height-24 f-line-height-27 one-2">
                    {{ singleStuInfor.userName }}
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="f-display-flex">
                  <div class="one-1 f-line-height-24 f-color-A4 f-stu-font-16">
                    学号：
                  </div>
                  <div class="f-color-3C f-line-height-24 f-line-height-27 one-2">
                    {{ singleStuInfor.stuNumber }}
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="stu-infor-box-item f-padding-bottom-10">
            <el-row>
              <el-col :span="8">
                <div class="f-display-flex">
                  <div class="one-1 f-line-height-24 f-color-A4 f-stu-font-16">
                    所属高校：
                  </div>
                  <div class="f-color-3C f-line-height-24 f-line-height-27 one-2">
                    {{ singleStuInfor.schoolName }}
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="f-display-flex">
                  <div class="one-1 f-line-height-24 f-color-A4 f-stu-font-16">
                    教学点：
                  </div>
                  <div class="f-color-3C f-line-height-24 f-line-height-27 one-2">
                    {{ singleStuInfor.teachingPointName }}
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="f-display-flex">
                  <div class="one-1 f-line-height-24 f-color-A4 f-stu-font-16">
                    专业层次：
                  </div>
                  <div class="f-color-3C f-line-height-24 f-line-height-27 one-2">
                    {{ singleStuInfor.majorTypeStr }}
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="stu-infor-box-item f-padding-bottom-10">
            <el-row>
              <el-col :span="8">
                <div class="f-display-flex">
                  <div class="one-1 f-line-height-24 f-color-A4 f-stu-font-16">
                    学习形式：
                  </div>
                  <div class="f-color-3C f-line-height-24 f-line-height-27 one-2">
                    {{ singleStuInfor.learnTypeStr }}
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="f-display-flex">
                  <div class="one-1 f-line-height-24 f-color-A4 f-stu-font-16">
                    入学批次：
                  </div>
                  <div class="f-color-3C f-line-height-24 f-line-height-27 one-2">
                    {{ singleStuInfor.enterBatchStr }}
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="f-display-flex">
                  <div class="one-1 f-line-height-24 f-color-A4 f-stu-font-16">
                    所属专业：
                  </div>
                  <div class="f-color-3C f-line-height-24 f-line-height-27 one-2">
                    {{ singleStuInfor.schoolMajorName }}
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="stu-infor-box-item f-padding-bottom-10">
            <el-row>
              <el-col :span="8">
                <div class="f-display-flex">
                  <div class="one-1 f-line-height-24 f-color-A4 f-stu-font-16">
                    在籍状态：
                  </div>
                  <div class="f-color-3C f-line-height-24 f-line-height-27 one-2">
                    {{
                      singleStuInfor.changeTypeName == null
                        ? "暂无"
                        : singleStuInfor.changeTypeName
                    }}
                  </div>
                </div>
              </el-col>
              <el-col :span="16">
                <div class="f-display-flex">
                  <div class="one-1 f-line-height-24 f-color-A4 f-stu-font-16">
                    所属班级：
                  </div>
                  <div class="f-color-3C f-line-height-24 f-line-height-27 one-2">
                    {{
                      singleStuInfor.className == null
                        ? "暂无"
                        : singleStuInfor.className
                    }}
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="payStu-detail">
        <div class="payStu-detail-title">
          注：请在缴费截止时间前，及时完成缴费。关闭此页面后，可在我的缴费中查找缴费信息，完成缴费。
        </div>
        <div class="payStu-detail-box f-display-flex" v-for="(item, index) in singleStuPayList" :key="index">
          <div class="f-display-flex">
            <div>缴费学年：</div>
            <div>{{ item.studyYear }}</div>
          </div>
          <!-- <div class="f-display-flex">
            <div>缴费学期：</div>
            <div>{{ item.studyTerm == 1 ? "春季" : "秋季" }}</div>
          </div> -->
          <div class="f-display-flex">
            <div>缴费金额：</div>
            <div>{{ item.shouldPayAmount }}</div>
          </div>
          <div class="f-display-flex">
            <div>缴费截止时间：</div>
            <div>{{ formatterDate(item.deadline) }}</div>
          </div>
          <div class="f-display-flex" v-if="singleStuPayList.length > 1">
            <div style="margin-right: 10px">
              <el-button size="small" type="primary" @click="alipayClcik(1, item)" v-if="item.isOpenAlipay == 1"
                :loading="payAliLoading">支付宝</el-button>
            </div>
            <div>
              <el-button size="small" type="success" v-if="item.isOpenWeChat == 1" :loading="payWeChatLoading"
                @click="weChatClick(1, item)">微 信</el-button>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center">
        <div v-if="singleStuPayList.length == 1" style="margin-right: 20px">
          <el-button size="small" type="primary" @click="alipayClcik" v-if="singleStuPayList[0].isOpenAlipay == 1"
            :loading="payAliLoading">支付宝</el-button>
          <el-button size="small" type="success" @click="weChatClick" v-if="singleStuPayList[0].isOpenWeChat == 1"
            :loading="payWeChatLoading">微 信</el-button>
        </div>

        <el-button size="small" @click="temporarilyClick">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="degreeReviewFeeDialogVisible" width="900px" :close-on-click-modal="false"
      title="学位评审费 消息提醒" center>
      <p style="white-space: nowrap; text-align: center">您已关联学位评审缴费批次，请及时完成缴费！</p>
      <div v-loading="degreeReviewFeeQueryLoading" class="degree-review-fee-tip">
        <p style="white-space: nowrap; text-align: center">请前往“我的缴费”菜单查看并完成缴费。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="goToDegreeReviewFee">前往操作</el-button>
        <el-button size="small" @click="degreeReviewFeeDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="微信支付" :visible.sync="wechatPayDialogVisible" width="400px" :close-on-click-modal="false" center
      @close="closeWechatDialog">
      <div class="wechat-pay-qrcode" v-loading="wechatQrLoading">
        <img v-if="wechatPayUrl" :src="wechatPayUrl" @load="wechatQrLoading = false" alt="微信支付二维码" />
        <p>请使用微信扫描二维码完成支付</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeWechatDialog">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
import microApp from "@micro-zoe/micro-app";
import common from "@/common/js/index.js";
import packageJson from "../../../package.json";
import { HubConnectionBuilder, HubConnectionState } from "@microsoft/signalr";
import "@/assets/styles/f-project.css";
import { utils } from "@/utils/util.js";
export default {
  components: { draggable },
  data() {
    return {
      disabled: true,

      user: JSON.parse(localStorage.getItem("user")) || {},
      drawer: false,
      readDialogVisible: false,
      temporarycolor: "",
      paixload: false,
      commonShow: false,
      activeName: "/userInfo/workTable",
      currentColor: localStorage.getItem("--primary"), //当前颜色
      colorList: [
        {
          value: "#009DF5",
          name: "堇色（默认）",
          icColor: "#44B1F5",
        },
        {
          value: "#4B7FFC",
          name: "蓝色",
          icColor: "#6690F5",
        },
        {
          value: "#5691FF",
          name: "柏林蓝",
          icColor: "#90CCCF",
        },
        {
          value: "#277b5a",
          name: "绿色",
          icColor: "#39906E",
        },
        {
          value: "#40CAA2",
          name: "浅绿色",
          icColor: "#90CCCF",
        },
        {
          value: "#7a4932",
          name: "咖色",
          icColor: "#885c47",
        },
        {
          value: "#148098",
          name: "靛色",
          icColor: "#2c8da3",
        },
        {
          value: "#D4553B",
          name: "红色",
          icColor: "#F88590",
        },
        {
          value: "#3C4454",
          name: "黑色",
          icColor: "#5E5C62",
        },
      ],
      menuList: [],
      disableTenant: {
        state: null, // 只有是0的情况下才是有效的2
        tenantDisablePrompt: "",
      },
      campusList: [], // 校区列表
      currentCampus: (sessionStorage.getItem("currentCampus") &&
        JSON.parse(sessionStorage.getItem("currentCampus"))) || {
        id: "",
        name: "",
      },
      packageJson,
      loading: false,
      searchValue: "",
      isUseColor: false,
      totalCount: "",
      drawerlaoding: false,
      Subscribe: [],
      adminUserType: null,
      currentMenus: [],
      terMenuList: [], //教师菜单
      stuMenuList: [], //学生菜单
      userInfor: {},
      currentIndex: 0,
      schoolList: [],
      schoolName: "",
      stuInforName: "",
      isNonDegree: 0, // 0=学历学生 1=非学历学生
      user: {
        mainLogoImage: "",
      },
      activate: "",
      current: "",
      switchSchoolVisible: false,
      switchSchoolId: "",
      activeNameCC: "",
      activeSwitch: "js",
      stuSchoolList: [],
      teaSchoolList: [],
      switchSchoolState: false,
      mentType: null,
      singleStuInfor: {},
      singleStuPayList: [],
      payStuShow: false,
      payWeChatLoading: false,
      payAliLoading: false,
      wechatPayDialogVisible: false,
      wechatPayUrl: "",
      wechatPayOrderId: null,
      wechatPayTimer: null,
      wechatQrLoading: false,//
      degreeReviewFeeDialogVisible: false,
      degreeReviewFeeItems: [],
      degreeReviewFeeQueryLoading: false,
    };
  },
  watch: {
    "$store.state.activate": {
      immediate: true,
      handler(val, old) {
        if (val == "clear") return;
        if (val?.indexOf("baseIsHistory") > -1) {
          val = val.replace("baseIsHistory", "");
        }
        let url = val;
        let arr = common.utils.inUrlGetId(url?.split("?")[0]);
        if (arr && arr.length) {
          this.activeName = arr[0]?.id;
          this.$store.commit("leftMenuChange", {
            menu: arr[0]?.menuDtos,
          });
        } else if (val) {
          this.activeName = val;
        }
      },
    },
    $route: {
      handler: function (val) {
        //let zhuMenu = localStorage.getItem("zhuMenu");
        // if (zhuMenu === "ziyuankongjian" && val.path === "/jxjy-resource-web") {
        //   this.$store.commit("isMenuChange", true);
        // } else {
        //   this.$store.commit("isMenuChange", false);
        // }
        //22
        if (val.name == "app") {
          this.$store.commit("isworkchange", true);
        } else {
          this.$store.commit("activateChange", {
            activate: null,
          });
          this.$store.commit("isworkchange", false);
        }
      },
      deep: true,
      immediate: true,
    },
    activate: {
      immediate: true,
      handler(val, old) {
        let locationList = localStorage.getItem("terActivate");
        this.activate = locationList;
        this.activeNameCC = locationList;
      },
    },
    adminUserType: {
      handler(val) {
        //老师和学生清除返回的颜色
        if (val === 3 || val === 4) {
          let user = JSON.parse(localStorage.getItem("user"));
          user.themeColor = "";
          if (user.themeColor && user.themeColor != "#009DF5") {
            this.isUseColor = true;
          }
          this.$store.commit("headstyleChange", user);
          user && localStorage.setItem("user", JSON.stringify(user));
          this.$Th.changeTheme(user.themeColor || "#009DF5");
          localStorage.setItem("--primary", user.themeColor || "#009DF5");
          microApp.setGlobalData({
            theme: user?.themeColor || localStorage.getItem("--primary"),
          });
        }
      },
    },
  },
  computed: {
    //GET_HEADSTYLE 头像等缓存数据通过vuex 传递
    ...mapGetters(["is_Work", "GET_HEADSTYLE"]),
  },
  beforeDestroy() {
    this.stopWechatPoll();
  },
  async created() { },
  async mounted() {
    // await this.getSchoolList(); //先获取校区
    await this.getUserUserType(); //获取用户类型
    await this.getUserInfo(); //获取校区之后在获取菜单
    //消息通知
    this.connect();
    this.getSubscribe();
    window.addEventListener("message", this.handleMessage);
  },
  methods: {
    //子应用做已读操作 基座消息未读数量改变
    handleMessage(event) {
      if (event.data == "消息数量改变") {
        this.getSubscribe();
      }
    },

    getHeaderBackground() {
      if (this.isUseColor) {
        return `var(--primary)`;
      } else {
        return `linear-gradient(
        to right,
        var(--primary),
        var(--primary-middle),
        var(--primary-right)
      )`;
      }
    },
    getUserUserType() {
      return this.$http({
        method: "GET",
        url: "/v1/jxjy-basic-data-service/api/common/current-user-type",
      }).then((res) => {
        if (res.length > 0) {
          //存用户类型
          this.adminUserType = res[0].userType;
          if (!localStorage.getItem("adminUserType")) {
            localStorage.setItem("adminUserType", this.adminUserType);
          }

          // 与 loginRedirect.vue 一致的 teaType 判断
          const info = res[0];
          if (info.userType === 3) {
            const identity = info.userIdentity?.[0];
            if (identity?.teaType === 1) {
              this.$emit("changeFlag");
              this.$router.replace({
                path: "/noFrame/jxjy-educational-web#/entryPlatform/details",
              });
              return;
            } else if (identity?.teaType === 2) {
              this.readDialogVisible = true;
              this.$emit("changeFlag");
              return;
            }
          }

          let _data = res;
          _data.forEach((item) => {
            if (item.userType == 4) {
              this.stuSchoolList = item.userIdentity;
            } else if (item.userType == 3) {
              this.teaSchoolList = item.userIdentity;
            }
          });
          if (this.stuSchoolList.length == 0) {
            this.activeSwitch = "js";
          } else if (this.teaSchoolList.length == 0) {
            this.activeSwitch = "xs";
          } else {
            this.activeSwitch = "js";
          }
          if (
            (this.stuSchoolList.length > 1 && this.teaSchoolList.length == 0) ||
            (this.teaSchoolList.length > 1 && this.stuSchoolList.length == 0)
          ) {
            this.switchSchoolState = true;
          } else if (
            this.stuSchoolList.length > 0 &&
            this.teaSchoolList.length > 0
          ) {
            this.switchSchoolState = true;
          }
          if (_data[0].userIdentity && _data[0].userIdentity.length) {
            this.schoolList = _data[0].userIdentity;
            this.switchSchoolId = _data[0].userIdentity[0].id;
            localStorage.setItem("userType", JSON.stringify(res));

            if (_data[0].userType != 0) {
              let typeSRQ = localStorage.getItem("switchTypes");
              // if (_data[0].userType == 4) {
              if (!localStorage.getItem("Student") && typeSRQ == 1) {
                localStorage.setItem("Student", this.stuSchoolList?.[0].id);
                localStorage.setItem("userTTR", 4);
                this.mentType = 4;
                this.schoolName = this.stuSchoolList[0].schoolName;
                this.stuInforName = this.stuSchoolList[0].studentStatus;
                this.isNonDegree = this.stuSchoolList[0].isNonDegree || 0;
                localStorage.setItem("isNonDegree", this.isNonDegree);

                this.queryStuIsFeesPay();
                this.queryDegreeReviewFeePayments();
              } else if (localStorage.getItem("Student") && typeSRQ == 1) {
                this.mentType = 4;
                localStorage.setItem("userTTR", 4);
                let arrId = localStorage.getItem("Student");
                let ass = this.stuSchoolList.find((item) => item.id == arrId);
                this.switchSchoolId = arrId;
                this.schoolName = ass.schoolName;
                this.stuInforName = ass.studentStatus;
                this.isNonDegree = ass.isNonDegree || 0;
                localStorage.setItem("isNonDegree", this.isNonDegree);
                this.queryDegreeReviewFeePayments();
              }
              if (!localStorage.getItem("schoolId") && typeSRQ == 2) {
                localStorage.setItem("schoolId", this.teaSchoolList?.[0].id);
                localStorage.setItem("userTTR", 3);
                this.mentType = 3;
                this.schoolName = this.teaSchoolList[0].schoolName;
              } else if (localStorage.getItem("schoolId") && typeSRQ == 2) {
                let arrId = localStorage.getItem("schoolId");
                let ass = this.teaSchoolList.find((item) => item.id == arrId);
                this.mentType = 3;
                this.switchSchoolId = arrId;
                this.schoolName = ass.schoolName;
              }
              if (!localStorage.getItem("switchTypes")) {
                if (this.adminUserType == 4) {
                  this.schoolName = this.stuSchoolList?.[0]?.schoolName;
                  this.stuInforName = this.stuSchoolList?.[0]?.studentStatus;
                  this.isNonDegree = this.stuSchoolList?.[0]?.isNonDegree || 0;
                  localStorage.setItem("isNonDegree", this.isNonDegree);
                  localStorage.setItem("Student", this.stuSchoolList?.[0].id);
                  localStorage.setItem("userTTR", 4);
                  this.queryStuIsFeesPay();
                  this.queryDegreeReviewFeePayments();
                  this.mentType = 4;
                } else if (this.adminUserType == 3) {
                  localStorage.setItem("userTTR", 3);
                  this.schoolName = this.teaSchoolList?.[0]?.schoolName;
                  localStorage.setItem("schoolId", this.teaSchoolList?.[0].id);
                  this.mentType = 3;
                } else {
                  localStorage.setItem("userTTR", this.adminUserType);
                  localStorage.setItem("schoolId", this.schoolList?.[0].id);
                }
              }

              // } else {

              // }
            }

            this.disTenant();
            return false;
          } else {
            this.$emit("disTenant", {
              tenantDisablePrompt: "无身份信息，请联系学校",
            });
            this.$emit("changeFlag", true);
          }
        } else {
          this.$emit("disTenant", {
            tenantDisablePrompt: "无身份信息，请联系学校",
          });
          this.$emit("changeFlag", true);
        }
      });
    },
    headerGoReadPlatform(type) {
      this.readDialogVisible = false;
      const path =
        type === "2"
          ? "/noFrame/jxjy-educational-web#/readPlatform/details?isMakeUp=1"
          : "/noFrame/jxjy-educational-web#/readPlatform/details";
      this.$router.replace({ path });
    },
    // 获取系统配置信息2
    getUserInfo() {
      this.$http({
        method: "GET",
        url: "/v1/system-service/api/account/user-login",
      }).then((res) => {
        //清除老师和学生默认主体颜色
        if (this.adminUserType === 3 || this.adminUserType === 4) {
          res.themeColor = "";
        }
        let user = JSON.parse(localStorage.getItem("user"));
        Object.assign(user, res);
        this.user = user;
        this.userInfor = user;
        if (res.themeColor && res.themeColor != "#009DF5") {
          this.isUseColor = true;
        }
        this.$store.commit("headstyleChange", user);
        user && localStorage.setItem("user", JSON.stringify(user));
        this.$Th.changeTheme(res.themeColor || "#009DF5");
        localStorage.setItem("--primary", res.themeColor || "#009DF5");
        microApp.setGlobalData({
          theme: user?.themeColor || localStorage.getItem("--primary"),
        });
        if (res.userName === "rczjzx") {
          this.user.mainLogoImage =
            "https://huaweicloudobs.ahjxjy.cn/a7cf473b4da3718040884b2deac6af3e.png";
        }
        let style = document.createElement("style");
        style.textContent = res.mainCssCode;
        document.head.appendChild(style);
        //this.disTenant();
      });
    },
    // 获取当前学校状态
    disTenant() {
      this.$http({
        mounted: "GET",
        url: "/v1/jxjy-system-service/api/base-data/state",
      })
        .then((res) => {
          this.$emit("disTenant", res);
          this.disableTenant = res;
          if (res.state == 0) {
            this.loadList();
          } else {
            this.$emit("changeFlag", true);
            // this.logout()
          }
        })
        .catch((err) => {
          this.$emit("changeFlag", true);
        });
    },
    loadList() {
      this.$http({
        url: "/v1/jxjy-system-service/api/menu/tree",
        method: "get",
      })
        .then((res) => {
          this.menuList = [...res];
          let _data = res;
          let list = _data.find((item) => item.menuUrl == "jiaoshikongjian");
          let stulist = _data.find(
            (item) => item.menuUrl == "xueShengKongJian",
          );
          this.terMenuList = [];
          if (this.mentType == 3) {
            this.terMenuList = list?.menuDtos;
          } else if (this.mentType == 4) {
            this.terMenuList = stulist?.menuDtos;
            // 非学历学生隐藏学籍异动、我的补考菜单
            if (this.isNonDegree === 1) {
              this.terMenuList = this.terMenuList.filter(
                (item) => !["学籍异动", "我的补考"].includes(item.name),
              );
            }
          }
          this.menuList = this.menuList.filter((e) => e.isShow == 1);

          if (this.adminUserType != 3) {
            if (packageJson.name != "base") {
              this.menuList.unshift({
                name: "工作台",
                id: "userInfo/workTable",
                isleftMenuChange: true,
                menuDtos: [],
                menuUrl: "userInfo/workTable",
              });
            }
            this.$store.commit("menuListChange", { list: this.menuList });
            sessionStorage.setItem("menuList", JSON.stringify(this.menuList)); // 供子应用使用
            this.$emit("changeFlag", true);
            const url = this.$route.fullPath.substring(1).replace("#/", "/");
            let arr = common.utils.inUrlGetId(url?.split("?")[0]);
            this.activeName = arr && arr[0]?.id;
            this.$store.commit("leftMenuChange", {
              menu: arr && arr[0]?.menuDtos,
            });
          } else {
            this.$store.commit("menuListChange", { list: this.terMenuList });
            sessionStorage.setItem(
              "menuList",
              JSON.stringify(this.terMenuList),
            ); // 供子应用使用
            this.$emit("changeFlag", true);
            let meArr = this.terMenuList.find((el) => el.id == this.activate);
            this.$store.commit("leftMenuChange", {
              menu: meArr && meArr.menuDtos,
            });
          }
        })
        .catch((err) => { });
    },
    tabClick(v, type) {
      let strRegex = /^https?:\/\//;
      let menu = this.menuList?.find((val) => {
        return val.id == v.name;
      });
      if (strRegex.test(menu.menuUrl)) {
        if (type == 2) {
          this.$refs.dropdown.hide();
          window.open(menu.menuUrl);
          return;
        }
        return;
      }
      if (type == 2) {
        // type == 2 是更多点击事件
        this.activeName = v.name;
        this.$refs.dropdown.hide();
      }
      if (type == 1) {
        // type == 1 点击事件
        this.activeName = v.name;
      }

      if (menu.isleftMenuChange) {
        this.$router.push({
          path: "/userInfo/workTable",
        });
        this.$store.commit("isworkchange", false);
        this.$emit("tabClickFutility", false);
        return;
      } else {
        this.$store.commit("isworkchange", true);
        //localStorage.setItem("zhuMenu", menu.menuUrl);
        // if (menu.menuUrl === "ziyuankongjian") {
        //   this.$store.commit("isMenuChange", true);
        // } else {
        //   this.$store.commit("isMenuChange", false);
        // }
        this.$store.commit("leftMenuChange", { menu: menu.menuDtos });
      }

      if (type == 1 || type == 2) {
        // 如果是点击情况下，非刷新情况
        // Start 直接点击第一个叶子节点菜单
        let leaf = {
          item: "",
          flag: false,
        };
        this.findLeaf(menu, leaf);
        if (strRegex.test(leaf.item.menuUrl)) {
          // 如果第一个叶子节点是外部链接则不进行单击
          this.$emit("tabClickFutility", true);
          return;
        }

        this.$emit("tabClick", leaf.item);
        // End
      }
      this.getObtainLoginUserInformation();
    },
    beforeLeave(activeName) {
      let strRegex = /^https?:\/\//;
      let menu = this.menuList?.find((val) => {
        return val.id == activeName;
      });
      if (strRegex.test(menu?.menuUrl)) {
        // 如果当前一级菜单是外部链接
        window.open(menu.menuUrl);
        return false;
      } else {
        return true;
      }
    },
    // 获取叶子结点 直接到达第一个菜单
    findLeaf(node, leaf) {
      if (leaf.flag) return;
      if (node.menuDtos.length === 0) {
        leaf.item = node;
        leaf.flag = true;
        return;
      } else {
        node.menuDtos.forEach((childNode) => {
          this.findLeaf(childNode, leaf);
        });
      }
    },
    dropdownClick(path) {
      switch (path) {
        case "logout":
          this.logout();
          break;
        case "/userInfo/index":
          sessionStorage.setItem("activate", "/userInfo/index");
          this.$router.push("/userInfo/index");
          this.$emit("tabClickFutility", false);
          this.activeName = null;
          break;
        case "theme":
          this.commonShow = true;
          this.currentColor = this.temporarycolor =
            localStorage.getItem("--primary");
          break;
      }
    },
    logout() {
      this.$http({
        url: "/v1/identity-service/api/account/logout",
        method: "post",
      }).then((res) => {
        let tenantCode = JSON.parse(localStorage.getItem("user"))?.tenantCode;
        localStorage.clear();
        sessionStorage.clear();
        // if (tenantCode) {
        //   window.location.replace(`/${tenantCode}/login`);
        // } else {
        //   window.location.replace("/login");
        // }
        window.open(`https://www.ahjxjy.cn`, "_self");
      });
    },
    //打开公共样式框2
    commonstyleShow() {
      this.commonShow = true;
      this.currentColor = localStorage.getItem("--primary");
      this.temporarycolor = localStorage.getItem("--primary");
    },
    //选择颜色
    switchColor(color) {
      if (color != "#009DF5") {
        this.isUseColor = true;
      } else {
        this.isUseColor = false;
      }
      this.currentColor = color;
      this.$Th.changeTheme(color);
    },
    //取消保存颜色
    nocolorcheck() {
      if (this.user.themeColor && this.user.themeColor != "#009DF5") {
        this.isUseColor = true;
      } else {
        this.isUseColor = false;
      }
      this.$Th.changeTheme(this.temporarycolor);
      localStorage.setItem("--primary", this.temporarycolor);
      this.commonShow = false;
    },
    //保存颜色
    switchColorok(color) {
      let user = JSON.parse(localStorage.getItem("user"));
      this.paixload = true;
      this.$http({
        method: "PUT",
        url:
          `/v1/system-service/api/account/theme-color?themeColor=` +
          encodeURIComponent(color),
      })
        .then(() => {
          this.temporarycolor = color;
          user.themeColor = color;

          localStorage.setItem("user", JSON.stringify(user));
          this.$Th.changeTheme(color);
          this.commonShow = false;
          this.paixload = false;
          this.user.themeColor = user.themeColor;
          this.$message.success("修改主题成功");
        })
        .catch(() => {
          this.currentColor = this.temporarycolor;
          user.themeColor = this.temporarycolor;
          localStorage.setItem("user", JSON.stringify(user));
          this.$Th.changeTheme(this.temporarycolor);
          this.paixload = false;
        });
    },
    sort() {
      this.disabled = !this.disabled;
    },
    onMove(e) {
      if (e.relatedContext.element.id == "workTable") return false;
      return true;
    },
    // 获取校区下拉列表
    async getSchoolList() {
      if (packageJson.name == "base") return;
      await this.$http({
        method: "GET",
        url: "/v1/jxjy-basic-data-service/api/campus/user",
      }).then((res) => {
        this.campusList = [...res];
        if (!this.campusList.length) {
          window.location.replace("/login");
        }
        if (!this.currentCampus.id) {
          this.saveCampus(this.campusList[0]);
        } else {
          this.campusList.map((item) => {
            if (
              item.id == JSON.parse(sessionStorage.getItem("currentCampus")).id
            ) {
              sessionStorage.setItem("currentCampus", JSON.stringify(item));
              this.currentCampus.name = item.name;
            }
          });
        }
      });
    },
    // 切换校区
    switchCampus(item) {
      this.loading = this.$loading({
        lock: true,
        text: "页面加载中...",
        spinner: "el-icon-loading",
        customClass: "menu-loading",
        background: "#fff",
      });
      this.$http
        .post("/v1/jxjy-basic-data-service/api/campus/" + item.id + "/verify")
        .then((res) => {
          this.loading.close();
          if (!res) {
            this.$confirm("检测到校区不存在或已删除，即将重载页面！", "提示", {
              confirmButtonText: "确定",
              type: "warning",
              showCancelButton: false,
              beforeClose: (action, ctx, close) => {
                close();
                sessionStorage.setItem("changemakeTai", 1);
                location.reload();
              },
            });
          } else {
            if (item.id == this.currentCampus.id) return;
            this.saveCampus(item);
            sessionStorage.setItem("changemakeTai", 1);
            location.reload();
          }
        });
    },

    // 保存校区
    saveCampus(item) {
      this.currentCampus = item;
      sessionStorage.setItem(
        "currentCampus",
        JSON.stringify(this.currentCampus),
      );
    },
    //获取消息模块
    getSubscribe(type) {
      if (type) {
        this.drawer = true;
        this.drawerlaoding = true;
      }

      this.$http
        .get("/v1/message-service/api/send-user-message?isRead=0")
        .then((r) => {
          this.drawerlaoding = false;
          this.Subscribe = r.items;
          this.totalCount = r.totalCount;
          this.issubscribe = true;
        })
        .catch((error) => {
          this.drawerlaoding = false;
        });
    },
    //跳转到页面
    gonewpath(path, id) {
      this.activate = path;
      localStorage.setItem("terActivate", path);

      this.$router.push({ path: "/message-web" });
      this.$store.commit("activateChange", {
        activate: id ? path + "?id=" + id : path,
      });
      this.drawer = false;
      this.drawerlaoding = false;
      if (id) {
        this.totalCount - 1;
      }
    },
    //开启消息推送
    connect() {
      if (process.env.NODE_ENV == "development") return;
      let url = "/messagehub/message-hub";
      let token = JSON.parse(
        localStorage.getItem("token"),
      ).encryptedAccessToken;
      const builder = new HubConnectionBuilder();
      this.connection = builder
        .withUrl(url, {
          accessTokenFactory: () => token,
        })
        .withAutomaticReconnect({ nextRetryDelayInMilliseconds: () => 5000 }) //断线重连
        .build();

      // 开始
      if (this.connection.state !== HubConnectionState.Connected) {
        this.connection.start().then((res) => {
          this.connection
            .invoke(
              "InitlnUser",
              JSON.parse(localStorage.getItem("user")).userId,
            )
            .then((res) => {
              // this.$message.success(`发送消息成功`);
            })
            .catch((error) => {
              this.$message.error(`发送消息错误${error}`);
            });
          // this.$message.success("SignalR 连接已建立200");
        });
      }
      this.connection.on("Message", (message) => {
        let title = "消息提醒";
        if (typeof message === "string") {
          try {
            const data = JSON.parse(message);
            title = data.title || title;
          } catch {
            title = message || title;
          }
        } else if (message && typeof message === "object") {
          title = message.title || title;
        }
        this.$notify({
          title: "收到一条新消息",
          message: title,
          duration: 5000,
        });
        this.getSubscribe();
        // this.$message.success(`收到消息：${message}`);
      });

      //自动重连成功后的处理11
      this.connection.onreconnected((connectionId) => {
        console.log(connectionId, "自动重新连接成功");
      });
      // 监听关闭
      this.connection.onclose((res) => {
        console.log("监听关闭", res);
      });
    },
    // 菜单点击
    menuClick(v, item) {
      localStorage.removeItem("isResources");
      let menu = this.terMenuList?.find((val) => {
        return val.id == v.name;
      });

      if (menu.menuUrl == "kong" || menu.menuUrl == "kon2") {
        this.$message({
          type: "warning",
          message: "正在开发，敬请期待....",
        });
        return;
      }
      this.$store.commit("isworkchange", true);
      this.$store.commit("leftMenuChange", { menu: menu.menuDtos });
      let arr = menu.menuUrl.split("/");
      if ("/" + arr[0] != this.$route.path) {
        this.$router.push({
          path: "/" + arr[0],
        });
      }
      this.$store.commit("activateChange", {
        activate: menu.menuUrl,
      });
      this.activate = menu.menuUrl;
      this.current = menu.menuUrl;
      localStorage.setItem("terActivate", menu.id);
      this.activeNameCC = menu.id;

      if (
        menu.menuUrl == "jxjy-resource-web/myResource/myResource" ||
        menu.menuUrl ==
        "jxjy-resource-web/schoolResource/schoolResource?publicTypeCode=xxzy" ||
        menu.menuUrl ==
        "jxjy-teacher-space-web/counselorModule/classManage/classManage"
      ) {
        localStorage.setItem("isResources", 1);
      }
      this.getObtainLoginUserInformation();
      this.$emit("teaTabClick", menu, 1);
    },
    // 切换学校
    switchSchoolChange() {
      this.$confirm(`您确定要切换当前选中的学校吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        dangerouslyUseHTMLString: true,
        callback: () => { },
        beforeClose: (action, ctx, close) => {
          if (action !== "confirm") {
            close();
            return;
          }
          ctx.confirmButtonLoading = true;

          if (this.adminUserType == 4) {
            localStorage.setItem("Student", this.switchSchoolId);
            localStorage.removeItem("schoolId");
            localStorage.setItem("switchTypes", 1);
            localStorage.setItem("userTTR", 4);
          } else if (this.adminUserType == 3) {
            localStorage.setItem("schoolId", this.switchSchoolId);
            localStorage.removeItem("Student");
            localStorage.setItem("switchTypes", 2);
            localStorage.setItem("userTTR", 3);
          }

          this.$router.push({
            path: "/userInfo/workTable",
          });
          this.goIndex();
          this.switchSchoolVisible = false;
          ctx.confirmButtonLoading = false;
          close();
          setTimeout(() => {
            location.reload();
          }, 500);
        },
      });
    },
    // 个人中心
    personalClick() {
      localStorage.removeItem("terActivate");
      this.activate = "";
      this.$router.push({
        path: "/userInfo/index",
      });
    },
    handleSwitch(e) {
      if (e.paneName == "xs") {
        this.adminUserType = 4;
      } else {
        this.adminUserType = 3;
      }
      localStorage.setItem("adminUserType", this.adminUserType);
    },
    swsscChange() {
      if (this.mentType == 3) {
        this.activeSwitch = "js";
      } else {
        this.activeSwitch = "xs";
      }
      this.switchSchoolVisible = true;
    },
    // 获取学生信息
    getStuInfor() {
      let stuId = localStorage.getItem("Student");
      let temporarily = localStorage.getItem("temporarily");

      this.$http
        .get(`/v1/jxjy-basic-data-service/api/base-student/${stuId}`)
        .then((res) => {
          let _data = res;
          this.singleStuInfor = _data;
          if (temporarily == 9) {
            this.payStuShow = false;
          } else {
            this.payStuShow = true;
            this.queryStuFeesOrder();
          }
        })
        .catch((err) => { });
    },
    // 查询学生的缴费订单信息
    queryStuFeesOrder() {
      let stuId = localStorage.getItem("Student");
      this.$http
        .get(`/v1/jxjy-basic-data-service/api/payment-record/student-list`)
        .then((r) => {
          let _data = r;
          // this.singleStuInfor = _data;
          this.singleStuPayList = _data;
        })
        .catch((error) => { });
    },
    // 查询学生是否需要缴费
    queryStuIsFeesPay() {
      // 非学历学生无需缴费
      if (this.isNonDegree === 1) return;
      this.$http
        .post(`/v1/jxjy-basic-data-service/api/payment-record/is-need-payment`)
        .then((r) => {
          let stuStatus = r;
          if (stuStatus) {
            this.getStuInfor();
          } else {
          }
        })
        .catch((error) => { });
    },
    formatterDate(time) {
      if (!time) return "";
      return utils.dateFormat(time, "yyyy-MM-dd hh:mm:ss");
    },
    queryDegreeReviewFeePayments() {
      const currentHash = window.location.hash.split("?")[0];
      if (
        !localStorage.getItem("Student") ||
        localStorage.getItem("userTTR") !== "4" ||
        currentHash === "#/myOrder/myOrder"
      ) {
        return;
      }
      this.degreeReviewFeeQueryLoading = true;
      this.$http({
        method: "GET",
        url: "/v1/jxjy-basic-data-service/api/payment-batch/my-payments",
        params: {
          skipCount: 0,
          maxResultCount: 10,
          sorting: "CreationTime Desc",
        },
      })
        .then((res) => {
          const items = Array.isArray(res && res.items) ? res.items : [];
          this.degreeReviewFeeItems = items.filter(
            (item) => item.displayStatus === 0
          );
          this.degreeReviewFeeDialogVisible = this.degreeReviewFeeItems.length > 0;
          this.degreeReviewFeeQueryLoading = false;
        })
        .catch(() => {
          this.degreeReviewFeeQueryLoading = false;
          this.$message.error("学位评审缴费信息获取失败，请稍后重试");
        });
    },
    // 跳转学位评审缴费23
    goToDegreeReviewFee() {
      this.degreeReviewFeeDialogVisible = false;
      window.location.href =
        window.location.origin +
        "/app/jxjy-student-space-web#/myOrder/myOrder?tab=otherFee";
    },
    temporarilyClick() {
      localStorage.setItem("temporarily", 9);
      this.payStuShow = false;
    },
    alipayClcik(index, item) {
      let stuId = localStorage.getItem("Student");
      this.payAliLoading = true;
      let data = {};
      if (index == 1) {
        data = {
          studentId: stuId,
          recordId: item.id,
          tradeType: 10,
          payType: 1,
        };
      } else {
        data = {
          studentId: stuId,
          recordId: this.singleStuPayList[0].id,
          tradeType: 10,
          payType: 1,
        };
      }

      this.$http
        .post(`/v1/jxjy-basic-data-service/api/payment-record/order`, data)
        .then((r) => {
          this.payAliLoading = false;
          let _data = r;
          if (_data.state == 0) {
            this.$message({
              message: _data.msg,
              type: "error",
            });
          } else if (_data.state == 1) {
            this.$nextTick(() => {
              const newWindow = window.open("", "_self");
              newWindow.document.write(_data.data);
              newWindow.focus();
            });
          }
        })
        .catch((error) => { });
    },
    weChatClick(index, item) {
      let stuId = localStorage.getItem("Student");
      const payRecord = index == 1 ? item : this.singleStuPayList[0];
      if (!payRecord || !payRecord.id) {
        this.$message.error("未找到缴费订单");
        return;
      }
      this.payWeChatLoading = true;
      const data = {
        studentId: stuId,
        recordId: payRecord.id,
        tradeType: 3,
        payType: 2,
      };
      this.wechatPayOrderId = payRecord.id;
      this.wechatPayUrl = "";
      this.wechatQrLoading = false;

      this.$http
        .post(`/v1/jxjy-basic-data-service/api/payment-record/order`, data)
        .then((r) => {
          this.payWeChatLoading = false;
          const payData = r && r.data !== undefined ? r.data : r;
          this.wechatPayOrderId = r.payOrderId || r.PayOrderId || this.wechatPayOrderId;
          if (r.state == 0) {
            this.$message.error(r.msg);
          } else if (r.state == 1) {
            if (typeof payData === "string" && payData.startsWith("weixin://")) {
              this.wechatPayUrl = "https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=" + encodeURIComponent(payData);
              this.wechatQrLoading = true;
              this.wechatPayDialogVisible = true;
              this.startWechatPoll();
            } else {
              this.$nextTick(() => {
                const newWindow = window.open("", "_self");
                newWindow.document.write(payData || r);
                newWindow.focus();
              });
            }
          }
        })
        .catch(() => {
          this.payWeChatLoading = false;
        });
    },
    startWechatPoll() {
      this.stopWechatPoll();
      this.wechatPayTimer = setInterval(() => {
        this.checkWechatPayResult();
      }, 3000);
    },
    stopWechatPoll() {
      if (this.wechatPayTimer) {
        clearInterval(this.wechatPayTimer);
        this.wechatPayTimer = null;
      }
    },
    closeWechatDialog() {
      this.wechatPayDialogVisible = false;
      this.stopWechatPoll();
    },
    checkWechatPayResult() {
      this.$http
        .post(`/v1/pay-service/api/pay-order/check-wechat-native-pay-state/${this.wechatPayOrderId}`)
        .then((r) => {
          if (r.orderState === 1) {
            this.stopWechatPoll();
            this.wechatPayDialogVisible = false;
            this.$message.success("支付成功");
            this.payStuShow = false;
            this.queryStuFeesOrder();
          } else if (r.orderState === 2) {
            this.stopWechatPoll();
            this.wechatPayDialogVisible = false;
            this.$message.error("支付失败");
          } else if (r.orderState === 3) {
            this.stopWechatPoll();
            this.wechatPayDialogVisible = false;
            this.$message.error("支付超时，已关闭");
          }
        })
        .catch(() => { });
    },
    // 返回工作台
    goIndex() {
      this.$router.push({
        path: "/userInfo/workTable",
      });
      localStorage.removeItem("isResources");
    },
    getObtainLoginUserInformation() {
      let userInfor = JSON.parse(localStorage.getItem("user"));
      let userTypeList = JSON.parse(localStorage.getItem("userType"));
      console.log(userTypeList, "userTypeuserTypeuserType");
      console.log(userInfor, "userInforuserInforuserInfor");
      let userName = "",
        schoolCode = "",
        campuszoneId = "",
        userType = "",
        classId = "",
        times = Date.now();
      if (userTypeList[0].userType == 1) {
        console.log("管理员");
        schoolCode = userTypeList[0].userIdentity[0].id;
        userName = userTypeList[0].userIdentity[0].userId;
        userType = userTypeList[0].userType;
      } else if (userTypeList[0].userType == 4) {
        console.log("学生");
        schoolCode = userTypeList[0].userIdentity[0].schoolId;
        userName = userTypeList[0].userIdentity[0].userId;
        userType = userTypeList[0].userType;
        campuszoneId = userTypeList[0].userIdentity[0].teachingPointId;
        classId = userTypeList[0].userIdentity[0].classId;
      } else if (userTypeList[0].userType == 3) {
        console.log("教师");
        schoolCode = userTypeList[0].userIdentity[0].id;
        userName = userTypeList[0].userIdentity[0].userId;
        userType = userTypeList[0].userType;
      } else if (userTypeList[0].userType == 2) {
        console.log("子管理员");
        schoolCode = userTypeList[0].userIdentity[0].id;
        userName = userTypeList[0].userIdentity[0].userId;
        userType = userTypeList[0].userType;
      } else if (userTypeList[0].userType == 0) {
        return false;
      }
      console.log(userName, schoolCode, "userNameschoolCodeuserNameschoolCode");

      // 动态创建 script 标签
      const script = document.createElement("script");
      script.type = "text/javascript";
      // https://onlineanalytics.ahjxjy.cn
      // http://jxjy.local/onlines
      script.src = `https://onlineanalytics.ahjxjy.cn/boot.js?userName=${userName}&userType=${userType}&schoolCode=${schoolCode}&campuszoneId=${campuszoneId}&classId=${classId}&_=${times}`;

      // 可选：监听脚本加载完成/失败事件
      script.onload = () => {
        console.log("脚本加载并执行成功");
      };
      script.onerror = (err) => {
        console.error("脚本加载失败", err);
      };

      // 将脚本插入到 body 或当前组件容器中
      document.body.appendChild(script);
      // 或插入到当前组件的 DOM 中：this.$el.appendChild(script)
    },
  },
};
</script>

<style lang="scss" scoped>
.d-i-b {
  display: inline-block;
}

.el-dropdown-link {
  cursor: pointer;
}

.header-box {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  box-shadow: 0px 2px 8px 0px rgba(97, 121, 167, 0.08);

  // background: #f1fcff;
  // background-image: url(../../assets/header-bg.png);
  // background-size: cover;
  .header-logo {
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;

    .name {
      color: #fff;
      font-size: 22px;
    }
  }
}

.log-box {
  width: 225px;
  text-align: center;
  padding-left: 40px;
  height: 46px;
  display: flex;
  align-items: center;
}

.log-box .imgbox {
  width: 100%;
  height: 100%;
}

::v-deep .el-tabs__item {
  font-size: 18px !important;
  max-width: 210px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  color: rgba(255, 255, 255, 0.66);
  font-family: SourceHanSansCN;
  font-style: normal;

  .el-tooltip {
    display: inline-block;
    max-width: 145px !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
}

::v-deep .el-tabs__item:hover {
  color: #fff;
  overflow: hidden;
}

::v-deep .el-tabs {
  .el-tabs__active-bar {
    height: 0px !important;
  }

  .is-active {
    color: #fff !important;
  }
}

.menu-title {
  flex: 1;
  display: flex;
  align-items: center;
  margin-left: 185px;

  .el-tabs {
    ::v-deep .el-tabs__item {
      padding: 0;
      padding-right: 52px;
    }

    ::v-deep .el-tabs__header {
      margin: 0;
    }
  }
}

::v-deep .el-tabs__nav-wrap::after {
  height: 0 !important;
}

::v-deep .user {
  display: flex;
  width: 58px;
  margin-right: 20px;

  .el-avatar {
    background: none !important;
    border-radius: 0 !important;
  }

  .user-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    // background: #fff;
    overflow: hidden;

    .userName {
      font-size: 12px;
    }

    .el-avatar--medium {
      width: 34px !important;
      height: 34px !important;

      // background: #fff !important;
      i {
        line-height: 34px !important;
      }
    }

    img {
      width: 34px !important;
      height: 34px !important;
    }
  }

  .user-center {
    display: flex;
    align-items: center;
  }

  .el-dropdown-link {
    display: flex !important;
    align-items: center !important;

    i:not(.el-icon-user-solid) {
      color: #333333;
      opacity: 0.7;
      margin-left: 10px !important;
    }
  }
}

::v-deep .el-dropdown-link {
  color: rgba(255, 255, 255, 0.7) !important;
}

.colortable {
  display: flex;
  flex-wrap: wrap;
}

.box-color {
  width: 184px;
  height: 142px;
  border-radius: 8px;
  margin: 15px 29px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;

  .box-name {
    margin-top: 6px;
  }

  .box-v {
    border: 1px solid #e6e8ed;
    background: #f8f8f9;
    margin-top: 13px;
    width: 158px;
    height: 95px;

    .box-v-min {
      margin-top: 14px;
      margin-left: 14px;
      margin-right: 14px;
      display: flex;
      align-items: center;

      .box-v-min-left {
        width: 26px;
        height: 67px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        .round {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-bottom: 5px;
        }

        .cross {
          width: 14px;
          height: 4px;
          margin-top: 5px;
          border-radius: 2px;
        }
      }

      .box-v-min-right {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        height: 67px;

        .box-v-min-right-header {
          height: 13px;
          background: #ececec;
        }

        .box-v-min-right-content {
          background: #fff;
          height: 54px;
        }
      }
    }
  }
}

.colorheard {
  margin-bottom: 20px;
}

.setting {
  position: relative;

  i {
    cursor: pointer;

    font-size: 20px;
    color: #585d69;
    opacity: 0.7;
  }
}

.user-name-text {
  margin-right: 30px;
  color: #fff;
  font-size: 18px;
}

::v-deep .search {
  margin-right: 30px;

  .el-input__inner {
    border-radius: 17px !important;
    border: 0;
    padding-left: 34px !important;
    color: #fff;
    background: rgba(255, 255, 255, 0.32);
  }

  .el-input__inner::placeholder {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
  }

  input {
    transition: all 0.23s ease-out;
  }

  input:focus {
    width: 188px;
    margin-left: -120px;
    background: rgba(255, 255, 255, 0.32);
  }

  .el-input__prefix {
    transition: all 0.23s ease-out;
    font-size: 14px;
    color: #fff;
  }

  :focus-within .el-input__prefix {
    transform: translateX(-120px);
  }
}

.more {
  font-size: 14px;
  margin-left: 40px;
  margin-bottom: 2px;
  color: #303133;
  cursor: pointer;

  .el-dropdown {
    color: #303133;
  }
}

.campus-box {
  margin-bottom: 4px;

  .el-dropdown-link {
    color: rgba(255, 255, 255, 0.7) !important;

    .el-icon-arrow-down {
      margin-left: 7px !important;
    }
  }
}

.tab-peon {
  color: #a9afbc;
  width: 100%;
  background-color: #ffffff !important;
}

::v-deep .el-alert--info {
  i:before {
    content: "\e6c9" !important;
    color: #a4a8b0;
  }

  &.is-light {
    background-color: #fff !important;
  }
}

::v-deep .el-alert {
  padding: 0 !important;

  .el-alert__icon {
    font-size: 12px;
    height: 11px;
  }

  .el-alert__content {
    padding: 0;
    display: flex;
  }

  .el-alert__title {
    font-size: 12px !important;
    color: #a4a8b0;
  }
}

.more-dropdown-box::-webkit-scrollbar {
  width: 0;
}

.more-dropdown-box {
  width: 630px;
  min-height: 300px;
  max-height: 450px;
  overflow-y: auto;
  display: inline-block;
  position: relative;

  .more-dropdown-item {
    width: 65px;
    height: 60px;
    margin: 10px;
    text-align: center;
    display: inline-block;

    .item-img-icon {
      display: inline-block;
      margin-top: 4px;
      margin-bottom: 6px;
      width: 32px;
      line-height: 32px;
      border: 1px solid var(--primary);
      border-radius: 12px;
      font-weight: 900;
      color: var(--primary);
    }

    .item-img-box {
      width: 80px;
    }

    .item-name {
      font-size: 14px;
      width: 80px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: flex;
      align-items: center;
      justify-content: center;

      .el-tooltip {
        display: inline-block;
        width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .item-name-span {
      display: inline-block;
      width: 80px;
      font-size: 16px;
    }
  }
}

.more-dropdown-sort {
  position: absolute;
  right: 10px;
  top: 5px;
  font-size: 12px;
  color: #a4a8b0;
  cursor: pointer;
  z-index: 999;
}

.drawer-title {
  padding: 20px;
  display: flex;
  border-bottom: 1px solid #ccc;
  align-items: center;
  justify-content: space-between;

  span {
    font-size: 16px;
    font-weight: 700;
  }

  .urlgo {
    margin-left: 100px;
    font-size: 12px;

    a {
      cursor: pointer;
      color: var(--primary);
    }
  }
}

.box-drawer {
  height: calc(100vh - 112px);
  overflow-y: auto;

  .title-li {
    padding: 20px;
    border-bottom: 1px dashed #ccc;
    cursor: pointer;
  }
}

.nodesic {
  margin: 100px auto;
  text-align: center;
  color: #a4a8a0;
  font-size: 12px;
}

.hovertitle:hover {
  // background-color: var(--primary-border-hover);
  background-color: #f2f5fc;

  .drawer-tie {
    color: #6a83d3;
  }
}

.drawer-tie {
  width: 280px;
  /* 容器的宽度 */
  // overflow: hidden;
  // white-space: nowrap; /* 防止换行 */
  // text-overflow: ellipsis; /* 显示省略号 */
  font-size: 14px;
}

.item-el-badge {
  position: absolute;
  left: 10px;
  top: -10px;

  ::v-deep .el-badge__content {
    border: none !important;
    height: 19px !important;
  }
}
</style>

<style scoped lang="scss">
.headerRR-box {
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.8);

  .headerRR-box-left {
    display: flex;
    align-items: center;
    width: auto;
    flex: 1 1 auto;
    min-width: 0;
  }

  .header-logo {
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: auto;
    flex: 0 0 auto;
    min-width: 0;
    padding-right: 12px;
    cursor: pointer;

    .name {
      color: #fff;
      font-size: 22px;
    }

    .log-box {
      width: clamp(170px, 16vw, 220px);
      max-width: 100%;
      text-align: center;
      height: 40px;
      display: flex;
      align-items: center;
    }

    .imgbox {
      width: 100%;
      height: auto;
      object-fit: contain;
    }
  }

  .header-right {
    margin-right: 43px;
    border-left: 1px dashed #dcdfe6;
    width: 30%;
    min-width: 0;
    flex: 0 0 25%;

    .user-r-lls {
      justify-content: space-around;
      display: flex;
      align-items: center;
      margin-top: 5px;
    }

    .user-box {
      flex: 3;
      margin-left: 15px;
      margin-right: 2%;
    }

    .user-box-box {
      display: flex;
      // justify-content: space-around;
      align-items: center;

      .user-info {
        margin-left: 16px;
        width: 230px;
      }

      .user-img {
        border-radius: 50%;

        .el-avatar {
          border: 2px solid #009df5;
        }


      }

      .user-name {
        color: #585d69;
        font-size: 18px;
        line-height: 28px;
        display: flex;
        width: 230px;
        justify-content: space-between;
      }

      .user-school {
        font-size: 16px;
        line-height: 24px;
        display: flex;
        width: 230px;
        justify-content: space-between;

        .school-name {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 160px;
        }

        .switch-school {
          font-size: 16px;
          color: var(--primary, #0bcc27);
          line-height: 18px;
          // padding: 0px 4px;
          border-radius: 5px;
          // background: rgba(0, 157, 245, 0.08);
          text-align: center;
          height: 18px;
          cursor: pointer;
          margin-top: 4px;
        }
      }

      .user-btn {
        margin-top: 10px;
      }
    }
  }
}

::v-deep .user-img img {
  width: 100%;
}

.shcooll-bbsr {
  display: flex;
  width: 100%;
  margin-left: 15px;
  min-height: 42px;
}

.stuInforName-iits {
  overflow-wrap: break-word;
  //// width: 92%;
}

.center-box {
  // background: #d2eafa;
  background: url("../../assets/hhe-bj.png") no-repeat;

  height: 120px;
}

.center-box-tst {
  background: #fff;
  margin: 0 24px;
  border-radius: 10px;
}

.semenu-horizontal-Qei9::v-deep .el-tabs__item {
  width: auto !important;
}

.menu-box::v-deep .el-tabs__item {
  font-size: 14px !important;
  width: auto;
  flex: 1 1 0;
  min-width: 0;
  height: 76px;
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  padding: 0 !important;
  margin-right: 4px;
  line-height: 36px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  color: rgba(255, 255, 255, 0.66);
  font-family: SourceHanSansCN;
  font-style: normal;

  .el-tooltip {
    display: inline-block;
    max-width: 145px !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
}

.menu-box::v-deep .el-tabs__item.is-active {
  background-color: rgba(0, 157, 245, 0.08);
}

.menu-box::v-deep .el-tabs__item:hover {
  background-color: rgba(0, 157, 245, 0.08);
}

.menu-box::v-deep .el-tabs__header {
  margin: 0;
  width: 100%;
}

.menu-box::v-deep .el-tabs__nav-wrap {
  width: 100%;
}

.menu-box::v-deep .el-tabs__nav-scroll {
  width: 100%;
}

.menu-box::v-deep .el-tabs__nav {
  width: 100%;
  display: flex;
}

.menu-box::v-deep .el-tabs__nav-wrap.is-scrollable {
  display: flex;
  align-items: center;
}

.teacher-menu {
  display: flex;
  align-items: center;
  margin-left: 10px;
  width: auto;
  flex: 1 1 auto;
  min-width: 0;

  .menu-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    min-width: 0;

    .item-box {
      width: 100%;
      height: 60px;
      margin: 4px 0;
    }

    .menu-item {
      margin-right: 0;
      line-height: 36px;

      .item-icon {
        text-align: center;
        height: 42px;

        i {
          width: 34px;
          height: 34px;
        }
      }

      .item-name {
        font-size: 14px;
        line-height: 20px;
        color: #000;
      }
    }
  }
}

.menu-item.is-active {
  background-color: rgba(0, 157, 245, 0.08);
}

.semenu-horizontal {
  display: flex;
  width: 100%;
  min-width: 0;
  border: 0;
  background: none;
}

.semenu-horizontal::v-deep .el-tabs__nav-wrap {
  width: 100%;
}

.semenu-horizontal::v-deep .el-tabs__nav-scroll {
  width: 100%;
}

.semenu-horizontal::v-deep .el-tabs__nav {
  width: 100%;
  display: flex;
}

.menu-item {
  width: 100%;
  height: 76px;
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  padding: 0 !important;
}

.switch-school-box {
  .el-radio-group label {
    padding: 10px 0;
    width: 45%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: flex;
    float: left;
    align-items: center;
  }
}

.switch-school-box .el-radio-group {
  width: 100%;
}

.switch-school-box::v-deep .el-tabs__item {
  color: #000;
}

.switch-school-box::v-deep .el-tabs .is-active {
  color: var(--primary, #0bcc27) !important;
}

.nodesic-llr {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 72%;
}

// 缴费弹窗
.stu-infor {
  -moz-box-shadow: 0px 1px 4px var(--primary);
  -webkit-box-shadow: 0px 1px 4px var(--primary);
  box-shadow: 0px 1px 4px var(--primary);
  border-radius: 8px;
  border: 1px solid var(--primary);
  padding: 10px 40px;
  margin-bottom: 16px;
  align-items: center;

  .stu-infor-img {
    width: 10%;
    border: 1px solid var(--primary);
    margin-right: 25px;
    display: flex;
    justify-content: center;
    -moz-box-shadow: 0px 1px 4px var(--primary);
    -webkit-box-shadow: 0px 1px 4px var(--primary);
    box-shadow: 0px 1px 4px var(--primary);
    border-radius: 8px;
  }

  .stu-infor-box {
    width: 90%;

    .stu-infor-box-item {
      width: 90%;

      .one-1 {
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        text-align: right;
        font-style: normal;
        width: 80px;
      }

      .one-2 {
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        text-align: left;
        font-style: normal;
      }
    }
  }
}

.payStu-detail {
  border: 1px solid red;
  padding: 10px 73px;
  -moz-box-shadow: 0px 1px 4px var(--primary);
  -webkit-box-shadow: 0px 1px 4px var(--primary);
  box-shadow: 0px 1px 4px var(--primary);
  border-radius: 8px;

  .payStu-detail-title {
    color: #f56c6c;
  }

  .payStu-detail-box {
    justify-content: space-between;
    padding: 25px 0;
  }
}

.wechat-pay-qrcode {
  text-align: center;
  padding: 20px 0;

  img {
    width: 220px;
    height: 220px;
  }

  p {
    margin-top: 16px;
    font-size: 14px;
    color: #666;
  }
}
</style>

<style lang="scss" scoped>
@media (min-width: 1280px) and (max-width: 1600px) {
  .user-name-text {
    font-size: 14px;
  }

  .menu-title .el-tabs::v-deep .el-tabs__item {
    padding-right: 40px;
  }
}

/* header.vue */
.headerRR-box-left {
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
}

.teacher-menu {
  min-width: 0;
  flex: 1 1 auto;
  margin-left: 20px;
}

.teacher-menu .menu-box {
  min-width: 0;
  width: 100%;
}

.menu-box::v-deep .el-tabs__item {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 1440px) {
  .teacher-menu {
    margin-left: 12px;
  }

  .menu-box::v-deep .el-tabs__item,
  .menu-item {
    height: 80px;
  }

  .menu-box .item-box {
    height: 64px;
    margin: 4px;
  }
}
</style>
